import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Popover } from 'antd';
import IntlMessages from '../../components/utility/intlMessages';
import LanguageSwitcher from '../LanguageSwitcher/index';
import actions from '../../redux/languageSwitcher/actions';
import config from '../LanguageSwitcher/config';

const { changeLanguage } = actions;

class TopbarLanguage extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.handleVisibleChange = this.handleVisibleChange.bind(this);
    this.hide = this.hide.bind(this);
    this.state = {
      visible: false,
    };
  }
  hide() {
    this.setState({ visible: false });
  }
  handleVisibleChange() {
    this.setState({ visible: !this.state.visible });
  }

  handleClick = (languageId) => {
    if(this.props.onChange !== undefined){
      this.props.onChange(languageId);
    }else{
      this.props.changeLanguage(languageId);
    }
  }

  render() {
    const { language, customlanguage, changeLanguage } = this.props;

    const lang = customlanguage || language;

    const languageButton = {
      width: '30px',
      height: 'auto',
      display: '-webkit-box',
      display: '-webkit-flex',
      display: '-ms-flexbox',
      display: 'inline-flex',
      margin: '0 10px 0 0',
      border: '1px solid #e4e4e4',
      outline: '0',
      padding: '0',
      background: 'none',
      WebkitBoxPack: 'center',
      WebkitJustifyContent: 'center',
      MsFlexPack: 'center',
      justifyContent: 'center',
      position: 'relative',
      cursor: 'pointer',
      WebkitBorderBadius: '3px',
      MozBorderBadius: '3px',
      MsTransition: '3px',
      OBorderBadius: '3px',
      borderBadius: '3px',
    }

    return (
      <Popover
        content={
          <div className="themeSwitchBtnWrapper">
            {config.options.map(option => {
              const { languageId, icon } = option;
              const customClass =
                languageId === lang.languageId
                  ? 'selectedTheme languageSwitch'
                  : 'languageSwitch';

              return (
                <button
                  type="button"
                  className={customClass}
                  key={languageId}
                  onClick={() => this.handleClick(languageId)}
                  style={languageButton}
                >
                  <img src={process.env.PUBLIC_URL + icon} alt="flag" style={{width: '100%', height: 'auto'}}/>
                </button>
              );
            })}
          </div>
        }
        trigger="click"
        visible={this.state.visible}
        onVisibleChange={this.handleVisibleChange}
        placement="bottomLeft"
      >
        <button
          type="button"
          key={`selected_${lang.languageId}`}
          style={languageButton}
        >
          <img src={process.env.PUBLIC_URL + lang.icon} alt="flag" style={{width: '100%', height: 'auto'}}/>
        </button>
      </Popover>
    );
  }
}

export default connect(
  state => ({
    ...state.LanguageSwitcher,
  }),
  { changeLanguage }
)(TopbarLanguage);
